import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import TouchAction from './TouchAction';
import { TextMediumLargeSize } from '../../constants/Fonts';

interface TouchActionGroupProps {
  sectionTitle: string;
  items: Array<{
    title: string;
    icon: string;
    value?: boolean;
    id?: string;
  }>;
  handleItemClick?: (title: string) => void;
  handleItemToggle?: (id: string, currentValue: boolean) => void;
  showSwitches?: boolean;
  loading?: boolean;
  error?: string;
}

const TouchActionGroup = ({ 
  sectionTitle, 
  items, 
  handleItemClick, 
  handleItemToggle,
  showSwitches = false,
  loading = false,
  error = ''
}: TouchActionGroupProps) => {
  return (
    <View style={styles.section}>
      <Text style={styles.label}>{sectionTitle}</Text>
      <View style={styles.containerRow}>
        {items.map((item, index) => (
          <TouchAction 
            key={item.id || index} 
            title={item.title} 
            icon={item.icon}
            value={item.value}
            showSwitch={showSwitches}
            loading={loading}
            error={error}
            handlePress={() => {
              if (showSwitches && handleItemToggle && item.id) {
                handleItemToggle(item.id, item.value || false);
              } else if (handleItemClick) {
                handleItemClick(item.title);
              }
            }}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    marginBottom: 40,
  },
  label: {
    fontSize: TextMediumLargeSize,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  containerRow: {
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
});

export default TouchActionGroup;